import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';

import Vehicles from './Vehicles';

const enhance = compose(withTranslation('OrderStop'));

export default enhance(Vehicles);
